import type { ReactNode } from 'react';

import { I } from '@/components/ri/icons';
import { TONE_COLOR, type StatusTone } from '@/components/ri/statusTones';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  tone?: StatusTone;
}

export function EmptyState({ icon, title, body, action, tone = 'neutral' }: EmptyStateProps) {
  const toned = tone === 'neutral' ? null : TONE_COLOR[tone];
  return (
    <div
      style={{
        padding: '32px 24px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        background: 'var(--surface-sunken)',
        borderRadius: 12,
        border: '1px dashed var(--border)',
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 999,
          background: toned?.bg ?? 'var(--surface-raised)',
          border: `1px solid ${toned?.dot ?? 'var(--border)'}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: toned?.fg ?? 'var(--text-tertiary)',
        }}
      >
        {icon ?? I.inbox}
      </div>
      <div style={{ fontWeight: 600, fontSize: 13 }}>{title}</div>
      {body && (
        <div className="ri-small" style={{ maxWidth: 280 }}>
          {body}
        </div>
      )}
      {action}
    </div>
  );
}
